import createPage from '../create-page'
import Info from '../info'

export default createPage(Info, 'INFO', true)



// WEBPACK FOOTER //
// ./src/components/info-page/index.js